const config = {
  env: "local",
  // apiUrl: "http://15.206.68.199:5664/admin/",
  apiUrl: "https://api.jaypanda.in/admin/",
  // apiUrl: "https://5s3wsb95-8000.inc1.devtunnels.ms/admin/",
};

export default config;
